module.exports = __webpack_public_path__ + "static/dm_automations_mobile-ecee78847f758a78bc6b58c079e9a20b.webp";